export class CommercialDocumentType {
    id: number = 0;
    document: string = null;
}
